import ApiService from './api.service'

const TextPageService = {
  async create(data) {
    try {
      return await ApiService.post('text-pages', data)
    } catch (error) {
      return error.response
    }
  },
  async textPages(page = 1) {
    try {
      return await ApiService.get('text-pages?page=' + page)
    } catch (error) {
      return error.response
    }
  },
  async deleteTextPageById(slideId) {
    try {
      const response = await ApiService.delete('text-pages/' + slideId)
      return response
    } catch (error) {
      return error.response.data
    }
  },
  async textPage(id) {
    try {
      return await ApiService.get('text-pages/' + id + '/show-admin/langs')
    } catch (error) {
      return error.response
    }
  },
  async updateTextPage(data, id) {
    try {
      return await ApiService.put('text-pages/' + id, data)
    } catch (error) {
      return error.response
    }
  }
}

export { TextPageService }
